import { FloatingTooltipContentText } from '../../Floating'
import { getRequestTagTooltip } from '../Request.utils'

export function getTooltipContent({
  archived,
  requestNumber,
  status,
  t,
  title,
}) {
  return (
    <FloatingTooltipContentText
      additionalText={t('ServiceRequest.TagTitleTooltipHintKey')}
      text={getRequestTagTooltip({ archived, requestNumber, status, t, title })}
    />
  )
}
